module.exports = __webpack_public_path__ + "static/media/logo-horizontal.9989d5ac.svg";